import { OnInit } from '@angular/core';
import { CsAgGridJsService } from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.service';
var CsAgGridActionRendererComponent = /** @class */ (function () {
    function CsAgGridActionRendererComponent(_csAgGrid) {
        var _this = this;
        this._csAgGrid = _csAgGrid;
        this.updateCellValue = function (rowData) {
            _this._csAgGrid.updateNodeCellValue(_this.rowNode, rowData);
        };
    }
    CsAgGridActionRendererComponent.prototype.ngOnInit = function () {
        this.rowNode = this.params.node;
    };
    CsAgGridActionRendererComponent.prototype.isDisable = function (action) {
        return typeof action.disable === 'function' ? action.disable(this.params['data']) : action.disable;
    };
    CsAgGridActionRendererComponent.prototype.isHide = function (action) {
        return typeof action.hide === 'function' ? action.hide(this.params['data']) : action.hide;
    };
    CsAgGridActionRendererComponent.prototype.isDisabledTooltip = function (action) {
        return typeof action.showTooltipIfDisabled === 'function' ? action.showTooltipIfDisabled(this.params['data']) : action.showTooltipIfDisabled;
    };
    CsAgGridActionRendererComponent.prototype.onClickAction = function (action) {
        if (this.isDisable(action)) {
            return;
        }
        action.onClick({
            action: action.id,
            data: this.params['data'],
            updateCellValue: this.updateCellValue
        });
    };
    CsAgGridActionRendererComponent.prototype.getActionUrl = function (action) {
        if (typeof action.linkUrl === 'function') {
            return action.linkUrl(this.params['data']);
        }
        return action.linkUrl || '#';
    };
    CsAgGridActionRendererComponent.prototype.onClickLinkAction = function (action, event) {
        if (this.isDisable(action)) {
            event.preventDefault();
            return;
        }
        if (event.ctrlKey || event.metaKey || event.button === 1) {
            return;
        }
        event.preventDefault();
        action.onClick({
            action: action.id,
            data: this.params['data'],
            updateCellValue: this.updateCellValue
        });
    };
    return CsAgGridActionRendererComponent;
}());
export { CsAgGridActionRendererComponent };
